import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Flow } from "../../types";

interface Props {
  value: string | null;
  onChange: (value: string | null) => void;
  flows: Flow[];
  disabled?: boolean;
  label?: string;
}

// Controlled flow picker shared by chatbot create and detail. The empty option
// maps to null (chatbot without a flow → OpenAI free mode on the BE).
export const FlowSelect = ({
  value,
  onChange,
  flows,
  disabled,
  label = "Flow",
}: Props) => {
  const labelId = "flow-select-label";
  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)}
      >
        <MenuItem value="">Nessun flow</MenuItem>
        {flows.map((f) => (
          <MenuItem key={f.id} value={f.id}>
            {f.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
